import $ from 'jquery';

const quotes = () => {
    const $containers = $('.js-quotes-slider');
    const objects = [];

    function init () {
        $containers.each(function () {
            objects.push(new Quotes($(this)));
        });
    }

    class Quotes {
        constructor ($container) {
            this.$container = $container;
            this.$quotes = $('.c-quote', $container);
            this.$renderer = $('.c-quote', $container).eq(0).clone();
            this.$next = $('.c-quote-nav__arrow--next', this.$renderer);
            this.$dots = $('.o-dots', $container);
            this.$dotsBtns = $('.o-dots button', $container);

            this.quotes = [];
            this.current = 0;
            this.amount = this.$quotes.length;

            this.debounceResize = null;

            // Add renderer in the container
            this.$renderer.addClass('is-renderer');
            this.$container.prepend(this.$renderer);

            this.getContent();
            this.initEvents();
            this.afterResize();
            this.updateDots();
        }

        getContent () {
            $('.c-quote:not(.is-renderer)', this.$container).each((i, el) => {
                // If more than one quote, display the nav
                if (this.amount > 1) {
                    $('.c-quote-content', el).addClass('nav-is-visible');
                } else {
                    // Hide the dots
                    this.$dots.hide();
                }

                // Store all the content from the quotes
                let content = {
                    title: $('.c-quote__title', el).html(),
                    content: $('.c-quote__content', el).html(),
                    authorName: $('.c-quote-author__name', el).html(),
                    authorCompany: $('.c-quote-author__company', el).html(),
                    authorImgSrc: $('.c-quote-author .c-quote-author__image', el).attr('data-src'),
                    illustrationSrc: $('.c-quote-image-container img', el).attr('data-src'),
                    illustrationSrcset: $('.c-quote-image-container img', el).attr('data-srcset'),
                    contentHeight: $('.c-quote-content', el).outerHeight()
                };
                this.quotes.push(content);
                $(el).addClass('is-hidden');
            });
        }

        // Add all the events on the page
        initEvents () {
            // When user click on next
            this.$next.on('click', () => { this.nextQuote() });
            // When user click on a dot button
            this.$dotsBtns.on('click', (e) => { this.onDotClick(e.currentTarget) });

            // When user resizes its window
            $(window).on('resize', () => {
                this.debounceResize = clearTimeout(this.debounceResize);
                this.debounceResize = setTimeout(this.afterResize.bind(this), 100);
            });
            // When fonts are loaded
            $(window).on('fontsLoaded', () => {
                this.afterResize();
            });
        }

        // When user click on a dot
        onDotClick (el) {
            const index = parseInt($(el).attr('data-index'));
            this.goToQuote(index);
        };

        // Go to a specific quote
        goToQuote (index) {
            this.current = index;
            this.updateContent();
        };

        // Switch the current quote to the next one
        nextQuote () {
            // Increment current quote index
            this.current += 1;
            // If we reach the max, back to 0
            if (this.current === this.amount) {
                this.current = 0;
            }
            this.updateContent();
        }

        // Update all the content of the quote
        updateContent () {
            // Update all HTML content
            $('.c-quote__title', this.$renderer).html(this.quotes[this.current].title);
            $('.c-quote__content', this.$renderer).html(this.quotes[this.current].content);
            $('.c-quote-author__name', this.$renderer).html(this.quotes[this.current].authorName);
            $('.c-quote-author__company', this.$renderer).html(this.quotes[this.current].authorCompany);

            // Update author image and background of the quote
            $('.c-quote-author .c-quote-author__image', this.$renderer).attr('src', this.quotes[this.current].authorImgSrc);
            $('.c-quote-author .c-quote-author__image', this.$renderer).attr('srcset', this.quotes[this.current].authorImgSrc);

            // Start content transitions
            $('.c-quote-content', this.$renderer).addClass('is-updating');
            // Update height of the content panel to create slide effect
            $('.c-quote-content', this.$renderer).css('height', this.quotes[this.current].contentHeight);

            // Fade In/Out background image
            const $prevImg = $('.c-quote-image-container img', this.$renderer).eq(0);
            const $tempImg = $prevImg.clone();
            $tempImg.addClass('is-fake');
            $tempImg.attr('src', this.quotes[this.current].illustrationSrc);
            $tempImg.attr('srcset', this.quotes[this.current].illustrationSrcset);
            $('.c-quote-image-container', this.$renderer).append($tempImg);

            $prevImg.addClass('is-hidden');
            $tempImg.addClass('is-hidden');
            setTimeout(() => {
                $tempImg.removeClass('is-hidden');

                // Remove transition class to display the content
                $('.c-quote-content', this.$renderer).removeClass('is-updating');
                setTimeout(() => {
                    $tempImg.removeClass('is-fake');
                    $('.c-quote-image-container img', this.$renderer).eq(0).remove();
                }, 350);
            }, 10);

            // Update the current quote index
            $('.c-quote__progress__current', this.$renderer).html(this.current + 1);

            // Update dots list
            this.updateDots();
        }

        // Calculate the max-height and set that to the renderer
        afterResize () {
            let minHeight = 0;
            this.$renderer.css('height', 'auto');
            $('.c-quote:not(.is-renderer)', this.$container).each((i, el) => {
                // Display the quote
                $(el).removeClass('is-hidden');

                // Calculate height of the content
                this.quotes[i].contentHeight = $('.c-quote-content', el).outerHeight();
                const height = $(el).height();
                if (height > minHeight) {
                    minHeight = height;
                }
                $(el).addClass('is-hidden')
            });
            // Set height from current quote
            $('.c-quote-content', this.$renderer).css('height', this.quotes[this.current].contentHeight);
            this.$renderer.css('height', minHeight);
        }

        updateDots () {
            this.$dots.find('li').removeClass('is-active');
            this.$dots.find('li').eq(this.current).addClass('is-active');
        }
    }

    return {
        init: init
    }
};

export default quotes;
